(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-chat"] && !Shopify.designMode) return;
  try {
    

  class KsWhatsAppChat extends HTMLElement {
    constructor() {
      super()

      this.chatButton = this.querySelector('#ks-whatsapp-chat-btn')
      this.dialog = this.querySelector('#ks-whatsapp-chat-dialog')
      this.userForm = this.querySelector('#ks-whatsapp-chat-dialog-user-form')
      this.userInput = this.querySelector('#ks-whatsapp-chat-dialog-user-input')

      this.whatsappNumber = (this.dataset.whatsappNumber || '')
        .replace(/\+/g, '')
        .replace(/\s/g, '')
        .replace(/-/g, '')
        .replace(/\(/g, '')
        .replace(/\)/g, '')

      this.handleChatButtonClick()
      this.handleCloseDialogButtonClick()
      this.handleKeyboardIssueMobile()
      this.handleFormSubmit()
    }

    handleChatButtonClick() {
      this.chatButton.addEventListener('click', () => {
        if (this.dataset.hasDialog === 'true') {
          this.openDialog()
        } else {
          this.openWhatsApp('')
        }
      })
    }

    openWhatsApp(message = '') {
      if (!this.whatsappNumber) {
        return
      }

      let whatsappUrl = `https://wa.me/${this.whatsappNumber}`

      if (message) {
        whatsappUrl += `?text=${encodeURIComponent(message)}`
      }

      window.location.href = whatsappUrl
    }

    openDialog() {
      if (this.dialog.hasAttribute('open')) {
        this.closeDialog()
        return
      }

      this.dialog.setAttribute('open', '')
      this.setAttribute('data-dialog-open', 'true')

      setTimeout(() => {
        this.userInput.focus()
      }, 300)

      setTimeout(() => {
        const typing = this.querySelector(
          '#ks-whatsapp-chat-dialog-msg-typing'
        )

        const message = this.querySelector(
          '#ks-whatsapp-chat-dialog-msg-text'
        )

        if (typing) {
          typing.style.display = 'none'
        }

        if (message) {
          message.style.display = 'block'
        }
      }, 2000)

      this.trapFocus()
    }

    closeDialog() {
      this.dialog.removeAttribute('open')
      this.setAttribute('data-dialog-open', 'false')
      this.chatButton.focus()
    }

    handleCloseDialogButtonClick() {
      const closeButton = this.querySelector(
        '#ks-whatsapp-chat-dialog-close'
      )

      if (!closeButton) {
        return
      }

      closeButton.addEventListener('click', () => {
        this.closeDialog()
      })
    }

    handleKeyboardIssueMobile() {
      this.userInput.addEventListener('focus', () => {
        this.dialog.setAttribute('data-keyboard-open', '')
      })

      this.userInput.addEventListener('blur', () => {
        this.dialog.removeAttribute('data-keyboard-open')
      })
    }

    trapFocus() {
      const focusableElements = this.dialog.querySelectorAll(
        'a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
      )

      if (!focusableElements.length) {
        return
      }

      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      const handleTab = (event) => {
        if (event.key !== 'Tab') {
          return
        }

        if (
          event.shiftKey &&
          document.activeElement === firstElement
        ) {
          event.preventDefault()
          lastElement.focus()
        } else if (
          !event.shiftKey &&
          document.activeElement === lastElement
        ) {
          event.preventDefault()
          firstElement.focus()
        }
      }

      this.addEventListener(
        'keyup',
        (event) => {
          if (event.code === 'Escape') {
            this.closeDialog()
          }
        }
      )

      this.dialog.addEventListener(
        'keydown',
        handleTab
      )
    }

    handleFormSubmit() {
      this.userForm.addEventListener(
        'submit',
        (event) => {
          event.preventDefault()

          const message = this.userInput.value.trim()

          this.openWhatsApp(message)
        }
      )
    }
  }

  if (!customElements.get('ks-whatsapp-chat')) {
    customElements.define(
      'ks-whatsapp-chat',
      KsWhatsAppChat
    )
  }


  } catch(e) { console.error(e); }
})();
})();
